<script setup lang="ts">
</script>
<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>Application customer support.</p>
    <p>
      Email: <a href="mailto:support@betpic.com" class="text-blue-600 dark:text-blue-400 underline">support@betpic.com</a><br>
    </p>
  </div>
</template>